import { Broker } from "@amzn/amazonmq-opsconsole-client";
import { widget } from "../utils";
import { CELL_HEIGHT, CELL_WIDTH } from "./common";

export function getRabbitNlbMetrics(broker: Broker): any[] {
    let metrics: any[] = [];

    const loadBalancerMetrics = [
        { title: "Active Flow Count", name: "ActiveFlowCount", stat: "Average" },
        { title: "New Flow Count", name: "NewFlowCount", stat: "Sum" },
        { title: "Unhealthy Routing Flow", name: "UnhealthyRoutingFlowCount", stat: "Sum" },
        { title: "Client Reset Count", name: "TCP_Client_Reset_Count", stat: "Sum" },
        { title: "ELB Reset Count", name: "TCP_ELB_Reset_Count", stat: "Sum" },
        { title: "Target Reset Count", name: "TCP_Target_Reset_Count", stat: "Sum" },
        { title: "Processed Bytes", name: "ProcessedBytes", stat: "Sum" },
        { title: "Load Balancer Capacity Units", name: "ConsumedLCUs", stat: "Average" }
    ];

    const targetGroupMetrics = [
        { title: "AMQP TLS Target Group Unhealthy Hosts", name: "UnHealthyHostCount", stat: "Maximum", nameSuffix: "amqp-tls" },
        { title: "Console TLS Target Group Unhealthy Hosts", name: "UnHealthyHostCount", stat: "Maximum", nameSuffix: "console-tls" }
    ];

    const startX = 0;
    const startY = 0;
    const xOffset = 12;
    const yOffset = 8;

    const addMetric = (config: any, index: number, metricParameters :any[]) => {
        const x = startX + (index % 2) * xOffset;
        const y = startY + Math.floor(index / 2) * yOffset;

        metrics.push(widget(
            config.title,
            broker.regionName,
            [metricParameters],
            x,
            y,
            CELL_WIDTH,
            CELL_HEIGHT
        ));
    };

    loadBalancerMetrics.forEach((metric, index) => {
        addMetric(metric, index, createLoadBalancerMetric(broker, metric.name, metric.stat, "left"));
    });

    const baseIndex = loadBalancerMetrics.length;
    targetGroupMetrics.forEach((metric, index) => {
        addMetric(metric, baseIndex + index, createTargetGroupMetric(broker, metric.stat, "left", metric.nameSuffix));
    });

    return metrics;
}

function createLoadBalancerMetric(
    broker: Broker,
    metricName: string,
    stat: string,
    yAxis: string
): any[] {
    const loadBalancerName = broker.brokerInfo.loadBalancer?.name;
    const metric = [
        "AWS/NetworkELB",
        metricName,
        "LoadBalancer",
        loadBalancerName,
        {
            stat,
            accountId: broker.summary.serviceAccountId,
            yAxis
        }
    ];
    return metric;
}

function createTargetGroupMetric(
  broker: Broker,
  stat: string,
  yAxis: string,
  filter: string
): any[] {
    const loadBalancerName = broker.brokerInfo.loadBalancer?.name;
    const targetGroups = broker.brokerInfo?.loadBalancer?.targetGroups;
    const matchingTargetGroup = targetGroups?.find(tg => tg.arn.includes(filter));
    const targetGroupName = matchingTargetGroup?.arn.split(":").pop() || 'no-target-group-found';
    const metric = [
        "AWS/NetworkELB",
        "UnHealthyHostCount",
        "TargetGroup",
        targetGroupName,
        "LoadBalancer",
        loadBalancerName,
        {
            stat,
            accountId: broker.summary.serviceAccountId,
            yAxis
        }
    ];
    return metric;
}
